import { render, staticRenderFns } from "./loadingProgramNew.vue?vue&type=template&id=402dfead&scoped=true&"
import script from "./loadingProgramNew.vue?vue&type=script&lang=js&"
export * from "./loadingProgramNew.vue?vue&type=script&lang=js&"
import style0 from "./loadingProgramNew.vue?vue&type=style&index=0&id=402dfead&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "402dfead",
  null
  
)

export default component.exports